<template>
    <div>
        <LeafletComponent
            id="map"
            :svgRendered="svgRendered"
            :originalColor="originalColor"
            :plazasSeleccionadas="butacasSeleccionadas"
        />
        <div class="col-12 col-md-6 p-0 pt-3 d-flex justify-content-between">
            <button class="btn mr-1" style="width: 50%;" @click="seleccionarTodasLasButacas" :disabled="butacasSeleccionadas.length === butacasFiltered?.length">Seleccionar todas</button>
            <button v-if="butacasSeleccionadas.length > 0" class="btn" style="width: 50%;" @click="limpiarTodasLasButacas">Limpiar todas</button>
       
        </div>
        <div class="col-12 p-0 pt-3" v-if="butacasSeleccionadas.length > 0">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input pr-5" type="checkbox" id="checkbox_permitir_liberacion_asientos" v-model="seleccionarTodas" />
                <label for="checkbox_permitir_liberacion_asientos" class="custom-control-label">
                    Cambiar precio en todas
                </label> 
            </div>
            <PorPlazasAbonos 
                :plazas="butacasSeleccionadas"
                :tipos="tipos"
                :seleccionarTodas="seleccionarTodas"
                :loadingButacas="loading"
                @getButacas="getButacas"
                @guardarPrecios="(params) => { $emit('guardarPrecios', params) }"
            />
        </div>
    </div>
</template>

<script>
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';
    import PorPlazasAbonos from './PorPlazasAbonos.vue';

    export default {
        props: {
            svg: {
                type: String,
                required: true
            },
            butacasFiltered: {
                type: Array,
                required: true
            },
            tipos: {
                type: Array,
                required: true
            },
            esMovil: {
                type: Boolean
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        created() {
            this.renderSvg();
        },
        data() {
            return {
                butacasSeleccionadas: [],
                svgRendered: null,
                originalColor: '#0CBA31',
                seleccionadaColor: '#8CA9D9',
                seleccionarTodas: false
            }
        },
        methods: {
            renderSvg() {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = this.svg;
                
                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');
                const isMobile = window.innerWidth <= 768;
                
                butacas.forEach(element => {
                    element.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(element);
                    const butaca = this.butacasFiltered.find(butaca => butaca.svg_id == svg_id);
                    
                    if (butaca) {
                        const title = this.getButacaName(butaca);
                        
                        if (!isMobile) {
                            this.drawPopover(element, butaca, title);
                        }

                        if(butaca.precios_online.length === 0 && butaca.precios_taquilla.length === 0) {
                            element.setAttribute('fill', 'gray');
                            butaca.originalColor = 'gray';
                        } else {
                            element.setAttribute('fill', this.originalColor);
                            butaca.originalColor = this.originalColor;
                        }

                        element.addEventListener('click', () => {
                            let isSeleccionado = JSON.parse(element.getAttribute('seleccionado'));

                            setTimeout(() => {
                                if (!this.isPanning) {
                                    if (!isSeleccionado) {
                                        element.setAttribute('fill', this.seleccionadaColor);
                                        element.setAttribute('seleccionado', 'true');
                                    } else {
                                        element.setAttribute('fill', this.originalColor);
                                        element.setAttribute('seleccionado', 'false');
                                    }
                                    this.clickRegion(butaca.id);
                                }
                            }, 150);
                        }); 
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
                setTimeout(() => {
                    this.$scrollTo('#map', 50);
                }, 190);
            },
            getButacaId(element) {
                const id = element.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            drawPopover(element, butaca, title = null) {
                let content = '';

                const preciosOnlineContent = this.generatePriceContent(butaca.precios_online);
                if (preciosOnlineContent !== '') {
                    content += '<b>Precios online:</b>';
                    content += preciosOnlineContent;
                }

                const preciosTaquillaContent = this.generatePriceContent(butaca.precios_taquilla);
                if (preciosTaquillaContent !== '') {
                    content += '<b>Precios taquilla:</b>';
                    content += preciosTaquillaContent;
                }

                const popoverOptions = {
                    title: title,
                    content: content,
                    trigger: 'hover',
                    html: true
                }

                new Popover(element, popoverOptions);
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> Visibilidad Reducida</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            clickRegion(butaca_id) {
                let butacaSeleccionada = this.butacasFiltered.find(butaca => butaca.id == butaca_id);
                if (butacaSeleccionada) {
                    butacaSeleccionada.seleccionada = butacaSeleccionada?.seleccionada && butacaSeleccionada.seleccionada ? false : true;
                    if (butacaSeleccionada.seleccionada) {
                        this.butacasSeleccionadas.push(butacaSeleccionada)
                    } else {
                        const index = this.butacasSeleccionadas.findIndex(butaca => butaca.id == butacaSeleccionada.id);
                        
                        if (index !== -1) {
                            this.butacasSeleccionadas.splice(index, 1);
                        }
                    }
                }
            },
            generatePriceContent(precios) {
                let content = '';

                content += '<ul class="pb-0 mb-0">';
                if (precios.length > 0) {
                    precios.forEach(precio => {
                        content += `<li>${precio.descripcion ?? precio.description}</li>`;
                    });
                } else {
                    content += '<li>No tiene precios configurados</li>'
                }
                content += '</ul>';

                return content;
            },
            getButacas() {
                this.$emit('getButacas');
            }, 
            seleccionarTodasLasButacas() {
                const butacas = this.svgRendered.querySelectorAll('[id^="butaca"]');
                butacas.forEach(element => {
                    element.setAttribute('fill', this.seleccionadaColor);
                    element.setAttribute('seleccionado', 'true');
                    const svg_id = this.getButacaId(element);
                    const butaca = this.butacasFiltered.find(butaca => butaca.svg_id == svg_id);
                    if (butaca && !this.butacasSeleccionadas.some(b => b.id === butaca.id)) {
                        this.butacasSeleccionadas.push(butaca);
                    }
                });
            },
            limpiarTodasLasButacas() {
                const butacas = this.svgRendered.querySelectorAll('[id^="butaca"]');
                butacas.forEach(element => {
                    const svg_id = this.getButacaId(element);
                    const butaca = this.butacasFiltered.find(butaca => butaca.svg_id == svg_id);
                    if (butaca) {
                        element.setAttribute('fill', butaca.originalColor);
                        element.setAttribute('seleccionado', 'false');
                        const index = this.butacasSeleccionadas.findIndex(b => b.id === butaca.id);
                        if (index !== -1) {
                            this.butacasSeleccionadas.splice(index, 1);
                        }
                    }
                });
            },
        },
        components: { LeafletComponent, PorPlazasAbonos }
    }
</script>